module.exports = __webpack_public_path__ + "images/sca-registry-footer.png";